import {
  FlatAspect,
  ItemAttributeOption,
} from "@/models/HomePageSearchResponse";

const BREED_OPTIONS: FlatAspect[] = [
  { id: "366", label: "American Saddlebred", slug: "american-saddlebred" },
  { id: "210", label: "Appaloosa", slug: "appaloosa" },
  { id: "211", label: "Arabian", slug: "arabian" },
  { id: "360", label: "Arabian Derivatives", slug: "arabian-derivatives" },
  {
    id: "australian-riding-pony",
    label: "Australian Riding Pony",
    slug: "australian-riding-pony",
  },
  {
    id: "381",
    label: "Australian Stock Horse",
    slug: "australian-stock-horse",
  },
  { id: "373", label: "Brumby", slug: "brumby" },
  { id: "401", label: "Caspian", slug: "caspian" },
  { id: "407", label: "Cleveland Bay", slug: "cleveland-bay" },
  { id: "214", label: "Clydesdale", slug: "clydesdale" },
  { id: "215", label: "Coloured", slug: "coloured-breed" },
  { id: "374", label: "Connemara", slug: "connemara" },
  { id: "422", label: "Dales Pony", slug: "dales-pony" },
  { id: "217", label: "Donkey / Mule", slug: "donkey-mule" },
  { id: "218", label: "Draught horse", slug: "draught-horse" },
  {
    id: "english-native-pony",
    label: "English Native Pony",
    slug: "english-native-pony",
  },
  { id: "219", label: "Friesian", slug: "friesian" },
  { id: "367", label: "Galloway", slug: "galloway" },
  { id: "220", label: "Gypsy horse", slug: "gypsy-horse" },
  {
    id: "german-riding-pony",
    label: "German Riding Pony",
    slug: "german-riding-pony",
  },
  { id: "362", label: "Hackney", slug: "hackney" },
  { id: "221", label: "Haflinger", slug: "haflinger" },
  {
    id: "384",
    label: "Irish Draught/Sport Horse",
    slug: "irish-draught-sport-horse",
  },
  { id: "379", label: "Knabstrupper", slug: "knabstrupper" },
  { id: "223", label: "Miniature Horses", slug: "miniature-horses" },
  { id: "410", label: "Miniature Ponies", slug: "miniature-ponies" },
  { id: "361", label: "Morgan", slug: "morgan" },
  { id: "226", label: "Other", slug: "other-breed" },
  { id: "227", label: "Paint", slug: "paint" },
  { id: "228", label: "Palomino", slug: "palomino-breed" },
  { id: "229", label: "Palouse", slug: "palouse" },
  { id: "363", label: "Percheron", slug: "percheron" },
  { id: "230", label: "Pinto", slug: "pinto-breed" },
  { id: "232", label: "Pony", slug: "pony" },
  { id: "233", label: "Quarter horse", slug: "quarter-horse" },
  { id: "234", label: "Riding Pony", slug: "riding-pony" },
  { id: "235", label: "Shetland", slug: "shetland" },
  { id: "236", label: "Shire Horse", slug: "shire-horse" },
  { id: "237", label: "Spanish / Andalusian", slug: "spanish-andalusian" },
  { id: "409", label: "Spanish Mustangs", slug: "spanish-mustangs" },
  { id: "364", label: "Sport Horse", slug: "sport-horse" },
  { id: "377", label: "Sportaloosa", slug: "sportaloosa" },
  { id: "238", label: "Standardbred", slug: "standardbred" },
  { id: "205", label: "Thoroughbred", slug: "thoroughbred" },
  { id: "365", label: "Waler", slug: "waler" },
  { id: "240", label: "Warmblood", slug: "warmblood" },
  { id: "241", label: "Welsh", slug: "welsh" },
];

export default BREED_OPTIONS;

export const BREED_ATTRIBUTE_OPTIONS: ItemAttributeOption[] = BREED_OPTIONS.map(
  (breed) => ({
    label: breed.label,
    value: breed.id,
  }),
);
